import * as Immutable from "immutable";
import { BaseEntity } from "../../baseEntity";
import { Panel } from "./panel";
import { VariableControl } from './variableControl';

export class VariablePanel extends Panel {
  static readonly CLASS_NAME: string = "VariablePanel";


  protected readonly HIDE_VARIABLES_WITH_EMPTY_VALUES = "hideVariablesWithEmptyValues";
  protected readonly HIDE_EMPTY_PANEL = "hideEmptyPanel";
  protected readonly ITEMS = "items";

  get hideVariablesWithEmptyValues(): boolean { return this.getInternalValue<boolean>(this.HIDE_VARIABLES_WITH_EMPTY_VALUES); }
  setHideVariablesWithEmptyValues(hideVariablesWithEmptyValues: boolean): this { return this.setInternalValue(this.HIDE_VARIABLES_WITH_EMPTY_VALUES, hideVariablesWithEmptyValues); }

  get hideEmptyPanel(): boolean { return this.getInternalValue<boolean>(this.HIDE_EMPTY_PANEL); }
  setHideEmptyPanel(hideEmptyPanel: boolean): this { return this.setInternalValue(this.HIDE_EMPTY_PANEL, hideEmptyPanel); }

  get items(): Immutable.List<VariableControl> { return this.getInternalValue<Immutable.List<VariableControl>>(this.ITEMS); }
  setItems(value: Immutable.List<VariableControl>): this { return this.setInternalValue(this.ITEMS, value); }

}